var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 3.9375C51.4235 3.9376 47.4017 4.87596 43.7461 6.67991C40.0905 8.48387 36.8991 11.105 34.4191 14.3404C31.9391 17.5757 30.237 21.3385 29.4447 25.3372C28.6524 29.336 28.7911 33.4634 29.85 37.4L3.9375 63.3125L3.9375 82.0625H22.6875V72.6875H32.0625V63.3125L41.4375 63.3125L48.625 56.125C50.8687 56.7375 53.175 57.05 55.5 57.0625C62.5448 57.0625 69.3011 54.264 74.2825 49.2825C79.264 44.3011 82.0625 37.5448 82.0625 30.5C82.0625 23.4552 79.264 16.6989 74.2825 11.7175C69.3011 6.73604 62.5448 3.9375 55.5 3.9375Z",
    stroke: "current",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1875 28.9375C61.9134 28.9375 63.3125 27.5384 63.3125 25.8125C63.3125 24.0866 61.9134 22.6875 60.1875 22.6875C58.4616 22.6875 57.0625 24.0866 57.0625 25.8125C57.0625 27.5384 58.4616 28.9375 60.1875 28.9375Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIconsvg);
export default __webpack_public_path__ + "static/media/admin-iconsvg.b884b90d245b640d26c9fe07ea0256a9.svg";
export { ForwardRef as ReactComponent };